import { render, staticRenderFns } from "./ShowDiscountAmountNotes.vue?vue&type=template&id=1e87ae2d&scoped=true&"
import script from "./ShowDiscountAmountNotes.vue?vue&type=script&lang=js&"
export * from "./ShowDiscountAmountNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87ae2d",
  null
  
)

export default component.exports